import type { TeamPayload } from '@/store/types/TeamPayload'
import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UpdateTeamPayload } from '@/modules/Teams/types'
import type { ApiResult } from '@/backend/darwin/types'

export type UpdateTeamRequestPayload = Omit<UpdateTeamPayload, 'id' | 'content' | 'type'>

/** Update team information */
export const updateTeam = async (
  teamId: number,
  updateParams: UpdateTeamRequestPayload,
): Promise<ApiResult<TeamPayload>> => {
  let response

  try {
    response = await api.put<TeamPayload>(`teams/${teamId}`, updateParams)
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.TEAM_UPDATE),
      ok: false,
    }
  }

  return {
    data: response.data,
    ok: true,
  }
}
